var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',_vm._g(_vm._b({attrs:{"prop":_vm.prop,"label":_vm.label,"width":_vm.width,"render-header":_vm.withTooltip('Номер автомата')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(_vm.$root.checkPermission('web_ta_main'))?_c('router-link',{attrs:{"to":_vm.to(row)}},[_vm._v("\n      "+_vm._s(_vm.serialNumber(row))+"\n    ")]):_c('div',[_vm._v("\n      "+_vm._s(_vm.serialNumber(row))+"\n    ")])]}}])},'el-table-column',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adfa9894","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-serial-number.vue
// module id = null
// module chunks = 